import React from 'react';
import styled from 'styled-components';
import { Card as StyledCard } from '../../../elements/Cards';

export const WidgetCard = ({
  heading,
  description,
  width,
  height,
  bgColor,
  borderColor,
  children,
}) => {
  return (
    <StyledCard
      width={width}
      height={height}
      bgColor={bgColor}
      borderColor={borderColor}
    >
      <Heading>{heading}</Heading>
      <Description>{description}</Description>
      {children}
    </StyledCard>
  );
};

export default WidgetCard;

const Heading = styled.h1``;
const Description = styled.p``;
